<template>
    <div>
        <basic-container>
            <el-form ref="searchFormRef" :model="selectForm" label-width="80px" v-show="searchBoxFlag">
                <el-row :gutter="24">
                      <el-col :span="6">
                          <el-form-item label="项目名称" prop="projectId" >
                              <el-select v-model="selectForm.projectId" placeholder="项目名称" style="width:100%" >
                                  <el-option
                                      v-for="item in projectList"
                                      :key="item.id"
                                      :label="item.name"
                                      :value="item.id">
                                  </el-option>
                              </el-select>
                          </el-form-item>
                      </el-col>

                      <el-col :span="6">
                          <el-form-item label="标准名称" prop="name" >
                              <el-input placeholder="标准名称"  clearable v-model="selectForm.name" maxlength="20" show-word-limit ></el-input>
                          </el-form-item>
                      </el-col>

                      <el-col :span="6">
                          <el-form-item label="状态" prop="name" >
                              <el-select clearable v-model="selectForm.status" placeholder="状态" style="width:100%" >
                                  <el-option
                                      v-for="item in statusList"
                                      :key="item.id"
                                      :label="item.name"
                                      :value="item.id">
                                  </el-option>
                              </el-select>
                          </el-form-item>
                      </el-col>
                      <el-col :span="6">
                          <div style="float:right">
                              <el-button type="primary" icon="el-icon-search" @click="search" size="small"> 搜索 </el-button>
                              <el-button @click="searchClear" icon="el-icon-delete" size="small"> 清空 </el-button>
                          </div>
                      </el-col>
                </el-row>
          </el-form>
          <avue-crud
            :option="option"
            :table-loading="loading"
            :data="standardList"
            :page.sync="page"

            ref="crud"
            @on-load="onLoad"
            @current-change="currentChange"
            @search-reset="searchReset"
            @selection-change="selectionChange"
            @size-change="sizeChange"
            @refresh-change="onLoad">
             <template slot="menuLeft">
            <el-button type="primary" icon="el-icon-plus" size="small" @click="addRecord"> 新 增</el-button>

            </template>
            <template slot="menuRight">
              <searchFromShow
                :searchBoxFlag.sync='searchBoxFlag'
                :removeHeight ='searchHeight'
                :option='option'
                :refOption="$refs.crud"
                ></searchFromShow>

            </template>
            <template slot-scope="scope" slot="menu">
            <el-button
                type="text"
                size="small"
                icon="el-icon-view"
                @click="checkStandard(scope.row)"
                >查看
            </el-button>
            <el-button
                type="text"
                size="small"
                icon="el-icon-edit"
                v-if='scope.row.status==1'
                @click="updateStandard(scope.row)"
                >编辑
            </el-button>
            <el-button
                type="text"
                size="small"
                icon="el-icon-video-play"
                v-if="scope.row.status==1"
                @click="forbidStandard(scope.row)"
                >停用
            </el-button>
            <el-button
                type="text"
                size="small"
                icon="el-icon-delete"

                @click="removeStandard(scope.row.id)"
                >删除
            </el-button>
            <el-button
                type="text"
                size="small"
                icon="el-icon-delete"
                @click="copyStandard(scope.row)"
                >复制
            </el-button>
            <el-button
                type="text"
                size="small"
                icon="el-icon-link"
                @click="relateDevice(scope.row)"
                >关联设备
            </el-button>

            </template>
        </avue-crud>
        </basic-container>
        <!-- 新增 -->
        <hr-dialog
         title="新增标准"
          v-if="addDialogVisable"
          :visible.sync="addDialogVisable"
          width='50%'
          :handleClose="handleClose">
          <template slot="body">
            <el-form ref="addRef" :rules="addStandardRules" :model="form" label-width="80px">
                <el-row :gutter="24">
                      <el-col :span="8">
                          <el-form-item label="项目名称" prop="projectId" >
                              <el-select v-model="form.projectId" placeholder="请选择 项目名称" style="width:100%" @change="projectIdChange">
                                  <el-option
                                      v-for="item in projectList"
                                      :key="item.id"
                                      :label="item.name"
                                      :value="item.id">
                                  </el-option>
                              </el-select>
                          </el-form-item>
                      </el-col>

                      <el-col :span="8">
                          <el-form-item label="标准名称" prop="name" style="width:100%" >
                              <el-input placeholder="请输入 标准名称"  v-model="form.name" maxlength="20" show-word-limit clearable ></el-input>
                          </el-form-item>
                      </el-col>


                      <el-col :span="24">
                         <el-form-item label="维保标准" prop="content" >
                             <el-input type="textarea" placeholder="请输入 维保标准" v-model="form.content"  rows='6' ></el-input>
                          </el-form-item>
                      </el-col>
                      <el-col :span="24">
                         <el-form-item label="备注" prop="description" >
                              <el-input  type="textarea" placeholder="请输入 备注信息" v-model="form.description" maxlength="200"></el-input>
                          </el-form-item>
                      </el-col>

                </el-row>
          </el-form>
          </template>
          <template slot="footer">
              <div style="float:right;margin-right:24px">
                            <el-button size="small" type="primary" icon="el-icon-circle-plus-outline" @click="AddSubmitStandard" style="margin-right: 20px"  >保存</el-button>
                            <el-button size="small"  icon="el-icon-circle-close"  @click="closeSubmitStandard">取消</el-button>
                         </div>
          </template>
        </hr-dialog>

       <!-- 查看 -->
        <hr-dialog
          title="查看标准"
          v-if="watchDialogVisable"
          :visible.sync="watchDialogVisable"
           width='50%'
          :handleClose="handleClose"
        >
          <template slot="body">
              <el-form  :model="form" label-width="80px">
                <el-row :gutter="24">
                      <el-col :span="8">
                          <el-form-item label="项目名称" prop="projectId" >
                              <el-select disabled v-model="watchFrom.projectId" placeholder="请选择" style="width:100%" @change="projectIdChange" disabled>
                                  <el-option
                                      v-for="item in projectList"
                                      :key="item.id"
                                      :label="item.name"
                                      :value="item.id">
                                  </el-option>
                              </el-select>
                          </el-form-item>
                      </el-col>

                      <el-col :span="8">
                          <el-form-item label="标准名称" prop="code" >
                              <el-input disabled  v-model="watchFrom.name"  ></el-input>
                          </el-form-item>
                      </el-col>


                      <el-col :span="8">
                          <el-form-item label="创建人" prop="code" >
                              <el-input  v-model="watchFrom.realName" disabled ></el-input>
                          </el-form-item>
                      </el-col>
                      <el-col :span="8">
                          <el-form-item label="创建时间" prop="code" >
                              <el-input  v-model="watchFrom.createTime"  disabled></el-input>
                          </el-form-item>
                      </el-col>
                     <el-col :span="24">
                         <el-form-item label="维保标准" prop="content" >
                             <el-input disabled type="textarea" v-model="watchFrom.content"  rows='6' ></el-input>
                          </el-form-item>
                      </el-col>
                      <el-col :span="24">
                         <el-form-item label="备注" prop="description" >
                              <el-input disabled  type="textarea" v-model="watchFrom.description" maxlength="200"></el-input>
                          </el-form-item>
                      </el-col>

                </el-row>
              </el-form>
          </template>
          <!-- <template slot="footer">
            <div style="float:right;margin-right:24px">

                            <el-button icon="el-icon-circle-close" @click="()=>{
                                    this.watchDialogVisable = false
                                }">取消</el-button>
                         </div>
          </template> -->
        </hr-dialog>
        <!-- 编辑 -->
        <hr-dialog
          title="编辑标准"
          v-if="updateDialogVisable"
          :visible.sync="updateDialogVisable"
          width='50%'
          :handleClose="handleClose"
        >

            <template slot="body">
              <el-form  ref="updateRef" :rules="addStandardRules" :model="updateFrom" label-width="80px">
                <el-row :gutter="24">
                      <el-col :span="8">
                          <el-form-item label="项目名称" prop="projectId" >
                              <el-select v-model="updateFrom.projectId" placeholder="请选择" style="width:100%">
                                  <el-option
                                      v-for="item in projectList"
                                      :key="item.id"
                                      :label="item.name"
                                      :value="item.id">
                                  </el-option>
                              </el-select>
                          </el-form-item>
                      </el-col>

                      <el-col :span="8">
                          <el-form-item label="标准名称" prop="name" >
                              <el-input  v-model="updateFrom.name" maxlength="20" show-word-limit></el-input>
                          </el-form-item>
                      </el-col>
                       <el-col :span="8">
                          <el-form-item label="创建人" prop="code" >
                              <el-input  v-model="updateFrom.realName" disabled ></el-input>
                          </el-form-item>
                      </el-col>
                      <el-col :span="8">
                          <el-form-item label="创建时间" prop="code" >
                              <el-input  v-model="updateFrom.createTime"  disabled></el-input>
                          </el-form-item>
                      </el-col>

                      <el-col :span="24">
                         <el-form-item label="维保标准" prop="content" >
                             <el-input type="textarea" v-model="updateFrom.content"  rows='6' ></el-input>
                          </el-form-item>
                      </el-col>
                      <el-col :span="24">
                         <el-form-item label="备注" prop="description" >
                              <el-input  type="textarea" v-model="updateFrom.description" maxlength="200"></el-input>
                          </el-form-item>
                      </el-col>

                </el-row>
              </el-form>
            </template>
            <template slot="footer">
              <div style="float:right;margin-right:24px">
                            <el-button size="small" type="primary" icon='el-icon-circle-check' @click="updateSubmitStandard" style="margin-right: 20px"  >修改</el-button>
                            <el-button size="small" icon="el-icon-circle-close" @click="UpdateSubmitStandardClose">取消</el-button>
                         </div>
            </template>
        </hr-dialog>

        <!-- 新增设备维保记录对话框 -->

        <hr-dialog
          title="已关联设备"
          v-if="relateDeviceFlag"
          :visible.sync="relateDeviceFlag"
          width="80%"
          :handleClose="handleClose"
        >
        <template slot="body">
          <relateDevice :isShowMenuLeft='isShowMenuLeft' :standardId='standardId' :projectId='projectId'></relateDevice>
        </template>
        </hr-dialog>
    </div>
</template>

<script>
import {
  getList,
  getBisDictData,
  add,
  getDetail,
  update,
  standardRemove,
  forbidStandard,
} from '@/api/crmedical/device/deviceInspectionStandard';
import {getDeviceMaintennanceStandardList,
addDeviceMaintenanceStandard,
getDeviceMaintennanceStandardDetail,
UpdateDeviceMaintennanceStandard,
deleteDeviceMaintennanceStandard,
stopDeviceMaintennanceStandard,
lookStandardUpkeepDevice,//关联设备启用查看
} from '@/api/crmedical/device/deviceMaintenaceStandard';
import { getProjectList } from '@/api/crmedical/project/project';
import Mtextarea from '@/components/textArea/index.vue';
import relateDevice from '@/components/device/maintenanceStandardDeviceRelation/deviceRelation';
import searchFromShow from '@/components/search-form-show/index'

export default {
  components: { Mtextarea, relateDevice ,searchFromShow},
  data() {

    return {
       searchBoxFlag:true,
        searchHeight:'',
      addStandardRules: {
        projectId: [{ required: true, message: '部门不能为空！', trigger: 'blur' }],
        name: [{ required: true, message: '标准名称不能为空！', trigger: 'blur' }],
        content: [{ required: true, message: '标准不能为空！', trigger: 'blur' }],
      },
      isShowMenuLeft: false,
      projectId: '',
      standardId: '', //标准id
      relateDeviceFlag: false, //关联设备对话框
      updateOrigin: [], //修改的原始副本
      updateDialogVisable: false, //编辑对话框
      updateFrom: {},
      watchOperateList: [],
      watchDialogVisable: false, //查看对话框
      watchFrom: {},

      operateList: [],
      standardList: [],
      projectList: [],
      statusList: [{ name: '启用', id: 1 }, { name: '停用', id: 0 }],
      addDialogVisable: false,
      option: {
        index: true,
        // selection: true,
        // reserveSelection:true,
        indexLabel: '序号',
        page: true,
        align: 'left',
        menuAlign: 'center',
        addBtn: false,
        editBtn: false,
        delBtn: false,
        border: true,
        height: 'auto',
        column: [
          {
            label: '项目名称',
            prop: 'projectName',
          },
          {
            label: '标准名称',
            prop: 'name',
          },
          {
            label: '创建人',
            prop: 'realName',
          },
          {
            label: '创建时间',
            prop: 'createTime',
          },
          {
            label: '状态',
            prop: 'status',
            dicData: [{ name: '启用', id: 1 }, { name: '停用', id: 0 }],
            props: {
              value: 'id',
              label: 'name',
            },
          },
        ],
      },
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      loading: false,
      selectForm: {},
      form: {
        projectId: '',
        name: '',
        standard: '',
        optionalOperationsList: [],
      },
    };
  },
  created() {
    this.initData();
  },
  mounted(){
      this.calcHeight()
    },
  methods: {
    calcHeight(){
      this.searchHeight = this.$refs.searchFormRef .$el.clientHeight
      this.option.height = this.bodyHeight - 340;
    },
    UpdateSubmitStandardClose() {
      this.updateDialogVisable = false;
    },
    forbidStandard(row) {
      this.$confirm('此操作将停用该标准, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        stopDeviceMaintennanceStandard({ id: row.id, status: 0 }).then((res) => {
          this.$message({
            type: 'success',
            message: '停用成功!',
          });
          this.onLoad();
        });
      });
    },
    removeStandard(id) {
      this.$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        deleteDeviceMaintennanceStandard(id).then(() => {
          this.$message({
            type: 'success',
            message: '删除成功!',
          });
          this.onLoad();
        });
      });
    },
    handleClose() {
      (this.form = {
        projectId: '',
        name: '',
        standard: '',
        optionalOperationsList: [],
      }),
        (this.watchFrom = {}),
        (this.updateFrom = {
          projectId: '',
          name: '',
          standard: '',
          optionalOperations: '',
          optionalOperationsList: [],
        });
      this.watchDialogVisable = false;
      this.updateDialogVisable = false;
      this.addDialogVisable = false;
      this.relateDeviceFlag = false;
    },
    search() {
       this.page.currentPage = 1
      this.onLoad();
    },
    searchClear() {
      this.selectForm.name = '';
      this.selectForm.status = '';
    },

    async copyStandard(row) {
      await getDeviceMaintennanceStandardDetail({ id: row.id }).then(({ data }) => {
        this.form = data;
        this.form.realName = row.realName;
        this.form.id = ""
        this.form.status = "1"
      });


      this.addDialogVisable = true;
    },
    //关联设备
    relateDevice(row) {
      console.log(row);
      this.isShowMenuLeft = row.status == 1 ? true : false;
      this.relateDeviceFlag = true;
      this.standardId = row.id;
      this.projectId = row.projectId;
    },
    //项目切换操作数据发生改变
    projectIdChange(val) {
      getBisDictData({ code: 'project_device_inspect_operation', projectId: val }).then((res) => {
        this.watchOperateList = res.data;
      });
    },
    //编辑提交
    updateSubmitStandard() {

        this.$refs['updateRef'].validate((valid) => {
          if (valid) {
            UpdateDeviceMaintennanceStandard(
             this.updateFrom
            ).then(() => {
              this.$message({
                showClose: true,
                message: '修改成功',
                type: 'success',
              });
              this.onLoad();
              this.updateDialogVisable = false;
            });
          } else {
            console.log('error submit!!');
            return false;
          }
        });

    },
    //编辑数据回显处理
    async updateStandard(row) {
      await getDeviceMaintennanceStandardDetail({ id: row.id }).then(({ data }) => {
        this.updateFrom = data;
        this.updateFrom.realName = row.realName;

      });




      // this.updateFrom.standard = arrContent.join('\n')
      this.updateDialogVisable = true;
    },
    //详情数据回显
    checkStandard(row) {

      getDeviceMaintennanceStandardDetail({ id: row.id }).then(({ data }) => {
        this.watchFrom = data;
        this.watchFrom.realName = row.realName;
        this.watchDialogVisable = true;

      });
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
    },
    currentChange(currentPage) {
      this.page.currentPage = currentPage;
    },
    //新增
    addRecord() {
      this.form = {}
      this.addDialogVisable = true;
      this.$set(this.form,'projectId',this.selectForm.projectId)
      this.$set(this.form,'name','')
      this.$set(this.form,'optionalOperationsList',[])

      getBisDictData({
        code: 'project_device_inspect_operation',
        projectId: this.form.projectId,
      }).then((res) => {
        this.watchOperateList = res.data;
      });
    },
    initData() {
      getProjectList().then((res) => {
        this.projectList = res.data;
        if (this.projectList.length > 0) {
          this.$set(this.selectForm, 'projectId', this.projectList[0].id);
          this.onLoad();
        }
      });
    },
    onLoad(page) {
      page = page || this.page;
      this.loading = true;
      if(this.selectForm.projectId){
        getDeviceMaintennanceStandardList(
        Object.assign(
          {},
          { current: this.page.currentPage, size: this.page.pageSize },
          this.selectForm
        )
      )
        .then(({ data }) => {
          this.standardList = data.records;
          this.page.total = data.total;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
      }else{
        this.loading = false;
      }

    },
    closeSubmitStandard() {
      this.addDialogVisable = false;
    },
    AddSubmitStandard() {

        this.$refs['addRef'].validate((valid) => {
          if (valid) {
            addDeviceMaintenanceStandard(
              Object.assign({}, this.form)
            ).then(() => {
              this.$message({
                showClose: true,
                message: '添加成功',
                type: 'success',
              });
              this.addDialogVisable = false;
              this.onLoad();
            });
          } else {
            console.log('error submit!!');
            return false;
          }
        });

    },
  },
};
</script>

<style>
</style>
